module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_petiteHover-aeb879346bafeb2f949f3fd3c369c7dd.jpg";